import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { UserIdPayload } from 'Interfaces/User';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: UserIdPayload) =>
    $actions.team.downgradeToUser(dispatch, payload),
  );
};
